<template>
  <div v-click-outside="focusOut" class="district-search">
    <label>
      <input v-model="query" placeholder="Zoek gemeente" class="district-search__input" type="text" @focus="focussed = true">
    </label>
    <div v-if="focussed && searchResults.length" class="district-search__suggestions">
      <div v-for="item in searchResults" 
           :key ="item.cbs" 
           class="district-search__suggestions-item" 
           @click="onSelect(item)"
           v-html="item.title._text"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "DistrictSearch",
  data() {
    return {
      query: "",
      focussed: false
    };
  },
  computed: {
    ...mapGetters("feed", ["getProvinceSetting"]),
    ...mapState("feed", ["communities"]),
    districts() {
      return this.communities[this.getProvinceSetting.key];
    },
    searchResults() {
      const result = Object.values(this.districts).filter(d => {
        // normalize special characters for better search results
        const theQuery = JSON.parse(JSON.stringify(this.query))
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        const title = d.title._text
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        return title.match(theQuery);
      });
      return this.query ? result : [];
    }
  },
  methods: {
    focusOut() {
      setTimeout(() => {
        this.focussed = false;
      }, 200);
    },
    onSelect(item) {
      this.$emit("onSelect", item, () => {
        this.query = item.title._text;
        this.focusOut();
      });
    }
  }
};
</script>

<style lang="scss">
@import "../util.scss";
.district-search {
  position: relative;
  padding: 12px 0 30px 0;
  &__input {
    width: 100%;
    height: 36px;
    font-size: 14px;
    border: 0;
    padding-left: 40px;
    border-bottom: 1px solid black;
    background: {
      image: url("../assets/search.svg");
      repeat: no-repeat;
      size: 20px;
      position: 6px center;
    }

    &:focus {
      outline: none;
    }
  }
  &__suggestions {
    position: absolute;
    top: 48px;
    left: 0;
    right: 0;
    z-index: 20;
    border: 1px solid $border-medium;
    box-shadow: 2px 4px 12px -2px rgba(0, 0, 0, 0.7);

    &-item {
      padding: 12px;
      background-color: white;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        background-color: $border;
      }
    }
  }
}
</style>
